import { createContext, useContext } from 'react'
import CallRootViewModel from 'messaging/calling/CallRootViewModel'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore This will never be null since it will be initialized by the app.
export const CallRootContext = createContext<CallRootViewModel>(null)

/**
 * Hook for using the above context.
 */
export function useCallRootViewModel() {
  return useContext(CallRootContext)
}
